/* frontend/src/api/public.js
   Public API helpers — use central apiService so requests go through
   the frontend proxy and share consistent base URL handling.
*/
import apiService from '../services/api';

export async function submitJoinClubInterest(payload) {
  // Use the shared ApiService so the request respects REACT_APP_API_URL
  // and the development proxy (`setupProxy.js`). The endpoint is
  // mounted under `/api/public` on the backend.
  return await apiService.request('/api/public/join-club-interest', {
    method: 'POST',
    body: JSON.stringify(payload)
  });
}

export default { submitJoinClubInterest };
